// Animated Icons
export { default as AnimatedLoading1 } from './AnimatedLoading1';
export { default as AnimatedLoading2 } from './AnimatedLoading2';
export { default as AnimatedLoading3 } from './AnimatedLoading3';
export { default as AnimatedLoadingColorful } from './AnimatedLoadingColorful';
export { default as AnimatedLoadingColorful2 } from './AnimatedLoadingColorful2'; // Logo Icons

export { default as LogoAliExpress } from './LogoAliExpress';
export { default as LogoEpoca } from './LogoEpoca';
export { default as LogoMagalu } from './LogoMagalu';
export { default as LogoMagaluDesktop } from './LogoMagaluDesktop';
export { default as LogoMagazine } from './LogoMagazine';
export { default as LogoNetshoesCircle } from './LogoNetshoesCircle';
export { default as LogoNetshoesRounded } from './LogoNetshoesRounded';
export { default as LogoParceiroMagalu } from './LogoParceiroMagalu';
export { default as LogoZattini } from './LogoZattini';
export { default as LogoKabum } from './LogoKabum';
export { default as LogoNetshoesName } from './LogoNetshoesName';
export { default as LogoZattiniName } from './LogoZattiniName';
export { default as LogoEpocaName } from './LogoEpocaName';
export { default as LogoBlogLu } from './LogoBlogLu';
export { default as LogoMagaluRecommends } from './LogoMagaluRecommends'; // General Icons

export { default as Accessibility } from './Accessibility';
export { default as Addition } from './Addition';
export { default as Airplane } from './Airplane';
export { default as AlarmClock } from './AlarmClock';
export { default as AlertOperation } from './AlertOperation';
export { default as AlertOutline } from './AlertOutline';
export { default as ArrowBack } from './ArrowBack';
export { default as ArrowDownRight } from './ArrowDownRight';
export { default as ArrowDropDown } from './ArrowDropDown';
export { default as ArrowDropUp } from './ArrowDropUp';
export { default as ArrowForward } from './ArrowForward';
export { default as ArrowLeft } from './ArrowLeft';
export { default as ArrowRight } from './ArrowRight';
export { default as BackToTop } from './BackToTop';
export { default as Blog } from './Blog';
export { default as BankSlip } from './BankSlip';
export { default as BoxChecked } from './BoxChecked';
export { default as BoxUnchecked } from './BoxUnchecked';
export { default as Burger } from './Burger';
export { default as Camera } from './Camera';
export { default as Card } from './Card';
export { default as Car } from './Car';
export { default as CarLift } from './CarLift';
export { default as CertainExchange } from './CertainExchange';
export { default as LuizaCard } from './LuizaCard';
export { default as CreditCard } from './CreditCard';
export { default as Cupom } from './Cupom';
export { default as CustomerContact } from './CustomerContact';
export { default as Chat } from './Chat';
export { default as ChatSuccess } from './ChatSuccess';
export { default as ChatWarning } from './ChatWarning';
export { default as Check } from './Check';
export { default as CheckThin } from './CheckThin';
export { default as ChevronDown } from './ChevronDown';
export { default as ChevronDownCircle } from './ChevronDownCircle';
export { default as ChevronLeft } from './ChevronLeft';
export { default as ChevronRight } from './ChevronRight';
export { default as ChevronUp } from './ChevronUp';
export { default as CheckCircle } from './CheckCircle';
export { default as Close } from './Close';
export { default as CloseCircle } from './CloseCircle';
export { default as CloseCircleFilled } from './CloseCircleFilled';
export { default as Coin } from './Coin';
export { default as Copy } from './Copy';
export { default as Clock } from './Clock';
export { default as Delivery1h } from './Delivery1h';
export { default as Delivery24h } from './Delivery24h';
export { default as DeliveryBox } from './DeliveryBox';
export { default as DeliveryFree } from './DeliveryFree';
export { default as DeliveryM } from './DeliveryM';
export { default as DeliveryRTomorrow } from './DeliveryRTomorrow';
export { default as DeliverySuccess } from './DeliverySuccess';
export { default as DeliveryWarning } from './DeliveryWarning';
export { default as DeliveryDefault } from './DeliveryDefault';
export { default as Dislike } from './Dislike';
export { default as Done } from './Done';
export { default as DoneCircle } from './DoneCircle';
export { default as Edit } from './Edit';
export { default as Exchange } from './Exchange';
export { default as ExchangeCircle } from './ExchangeCircle';
export { default as ExpressDelivery } from './ExpressDelivery';
export { default as ExtendedWarranty } from './ExtendedWarranty';
export { default as ErrorOutline } from './ErrorOutline';
export { default as Facebook } from './Facebook';
export { default as FastDelivery } from './FastDelivery';
export { default as FastMarket } from './FastMarket';
export { default as FeaturedVideo } from './FeaturedVideo';
export { default as Filter } from './Filter';
export { default as Guarantee } from './Guarantee';
export { default as GuaranteeFilled } from './GuaranteeFilled';
export { default as Heart } from './Heart';
export { default as HelpOutline } from './HelpOutline';
export { default as InfoCircle } from './InfoCircle';
export { default as Instagram } from './Instagram';
export { default as Like } from './Like';
export { default as Lightning } from './Lightning';
export { default as Link } from './Link';
export { default as LinkedIn } from './LinkedIn';
export { default as LocalActivity } from './LocalActivity';
export { default as MailOutline } from './MailOutline';
export { default as MoneyPig } from './MoneyPig';
export { default as OpenLink } from './OpenLink';
export { default as Package } from './Package';
export { default as PackageAlert } from './PackageAlert';
export { default as Pix } from './Pix';
export { default as Phone } from './Phone';
export { default as Person } from './Person';
export { default as EmailAt } from './EmailAt';
export { default as Notifications } from './Notifications';
export { default as DeliveryDefaultFilled } from './DeliveryDefaultFilled';
export { default as PickupStore } from './PickupStore';
export { default as Pin } from './Pin';
export { default as Pinterest } from './Pinterest';
export { default as Play } from './Play';
export { default as Podcast } from './Podcast';
export { default as PodcastCircle } from './PodcastCircle';
export { default as PriceTag } from './PriceTag';
export { default as PrivacyPolitic } from './PrivacyPolitic';
export { default as Profile } from './Profile';
export { default as Question } from './Question';
export { default as Receipt } from './Receipt';
export { default as ReturnCircle } from './ReturnCircle';
export { default as RobberyTheft } from './RobberyTheft';
export { default as RobberyTheftFull } from './RobberyTheftFull';
export { default as Rules } from './Rules';
export { default as Sac } from './Sac';
export { default as Search } from './Search';
export { default as SellerStore } from './SellerStore';
export { default as Send } from './Send';
export { default as Share } from './Share';
export { default as ShipmentInAccordance } from './ShipmentInAccordance';
export { default as ShoppingBag } from './ShoppingBag';
export { default as ShoppingBagFast } from './ShoppingBagFast';
export { default as Sort } from './Sort';
export { default as SortArrows } from './SortArrows';
export { default as Star } from './Star';
export { default as StarHalf } from './StarHalf';
export { default as StarOutline } from './StarOutline';
export { default as StarGroup } from './StarGroup';
export { default as Store } from './Store';
export { default as SecurityTip } from './SecurityTip';
export { default as Telegram } from './Telegram';
export { default as Tiktok } from './Tiktok';
export { default as Tools } from './Tools';
export { default as TotalSales } from './TotalSales';
export { default as Tune } from './Tune';
export { default as ThumbUp } from './ThumbUp';
export { default as Twitter } from './Twitter';
export { default as UserReviewIcon } from './UserReviewIcon';
export { default as Video } from './Video';
export { default as VideoCircle } from './VideoCircle';
export { default as ViewModule } from './ViewModule';
export { default as WhatsApp } from './WhatsApp';
export { default as Youtube } from './Youtube';
export { default as QRCode } from './QRCode';
export { default as Timer } from './Timer';
export { default as WarningOutline } from './WarningOutline';
export { default as Muted } from './Muted';
export { default as Unmuted } from './Unmuted';
export { default as VerifiedBadge } from './VerifiedBadge';
export { default as Conversation } from './Conversation'; // Category Icons (magalu)

export { default as CategoryAF } from './CategoryAF';
export { default as CategoryAM } from './CategoryAM';
export { default as CategoryAR } from './CategoryAR';
export { default as CategoryAU } from './CategoryAU';
export { default as CategoryBA } from './CategoryBA';
export { default as CategoryBB } from './CategoryBB';
export { default as CategoryBP } from './CategoryBP';
export { default as CategoryBR } from './CategoryBR';
export { default as CategoryBS } from './CategoryBS';
export { default as CategoryCA } from './CategoryCA';
export { default as CategoryCI } from './CategoryCI';
export { default as CategoryCF } from './CategoryCF';
export { default as CategoryCM } from './CategoryCM';
export { default as CategoryCO } from './CategoryCO';
export { default as CategoryCP } from './CategoryCP';
export { default as CategoryCR } from './CategoryCR';
export { default as CategoryEA } from './CategoryEA';
export { default as CategoryED } from './CategoryED';
export { default as CategoryEP } from './CategoryEP';
export { default as CategoryES } from './CategoryES';
export { default as CategoryET } from './CategoryET';
export { default as CategoryFM } from './CategoryFM';
export { default as CategoryFS } from './CategoryFS';
export { default as CategoryGA } from './CategoryGA';
export { default as CategoryIA } from './CategoryIA';
export { default as CategoryIM } from './CategoryIM';
export { default as CategoryIN } from './CategoryIN';
export { default as CategoryLI } from './CategoryLI';
export { default as CategoryMD } from './CategoryMD';
export { default as CategoryME } from './CategoryME';
export { default as CategoryMO } from './CategoryMO';
export { default as CategoryMS } from './CategoryMS';
export { default as CategoryNA } from './CategoryNA';
export { default as CategoryPA } from './CategoryPA';
export { default as CategoryPE } from './CategoryPE';
export { default as CategoryPF } from './CategoryPF';
export { default as CategoryPI } from './CategoryPI';
export { default as CategoryRE } from './CategoryRE';
export { default as CategorySA } from './CategorySA';
export { default as CategorySE } from './CategorySE';
export { default as CategoryTB } from './CategoryTB';
export { default as CategoryTE } from './CategoryTE';
export { default as CategoryTF } from './CategoryTF';
export { default as CategoryUD } from './CategoryUD';
export { default as CategoryDE } from './CategoryDE';
export { default as CategoryRG } from './CategoryRG';
export { default as CategoryCJ } from './CategoryCJ';
export { default as CategoryFJ } from './CategoryFJ'; // Services Icons

export { default as ServiceBabyShower } from './ServiceBabyShower';
export { default as ServiceCard } from './ServiceCard';
export { default as ServiceConsortium } from './ServiceConsortium';
export { default as ServiceControlPlan } from './ServiceControlPlan';
export { default as ServiceGoldClient } from './ServiceGoldClient';
export { default as ServiceHomeIntelligent } from './ServiceHomeIntelligent';
export { default as ServiceHomeSecurity } from './ServiceHomeSecurity';
export { default as ServiceLuizaSeg } from './ServiceLuizaSeg';
export { default as ServiceMarketplace } from './ServiceMarketplace';
export { default as ServiceMagaluEmp } from './ServiceMagaluEmp';
export { default as ServiceMarriage } from './ServiceMarriage';
export { default as ServicePartner } from './ServicePartner';
export { default as ServiceSolutions } from './ServiceSolutions';
export { default as Christmas } from './Christmas';
export { default as Offers } from './Offers';
export { default as CupomPromotion } from './CupomPromotion'; // Generic

export { default as GenericImageIcon } from './GenericImageIcon';